import { makeStyles } from '@material-ui/core/styles';

export const useTestFormSectionStyles = makeStyles((theme) => ({
    testFormSection: {
        marginBottom: theme.spacing(9), // 72px
        '& .MuiFormControlLabel-root': {
            marginTop: theme.spacing(0.125),
        },
    },

    testSubFormSection: {
        marginBottom: 0,
    },

    testSubSectionContainer: {
        '& > .TestSubFormSection': {
            marginTop: theme.spacing(6), // 48px
        },

        '& > .TestSmallSubFormSection': {
            marginTop: theme.spacing(3), // 24px
        },
    },
}));
